/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".rootOverflow_1b9bf32d{overflow:auto}.item_1b9bf32d{height:30px}"}]);
export const rootOverflow = "rootOverflow_1b9bf32d";
export const item = "item_1b9bf32d";